import { render, staticRenderFns } from "./CertificateModal.vue?vue&type=template&id=675bff5a&scoped=true"
import script from "./CertificateModal.vue?vue&type=script&lang=ts"
export * from "./CertificateModal.vue?vue&type=script&lang=ts"
import style0 from "./CertificateModal.vue?vue&type=style&index=0&id=675bff5a&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675bff5a",
  null
  
)

export default component.exports